import type { MomentumMetric } from '@/domains/types';

export function MomentumPanel({ metrics }: { metrics: MomentumMetric[] }) {
  return (
    <section aria-label="Momentum">
      <h2 className="mb-3 text-[10px] font-extrabold uppercase tracking-hottr-stamp text-white/48">
        Momentum
      </h2>
      <ul className="grid grid-cols-2 gap-2 sm:grid-cols-4">
        {metrics.map((m) => (
          <li
            key={m.key}
            className="rounded-sm border border-white/[0.08] bg-white/[0.03] px-3 py-4"
          >
            <p className="font-display text-2xl font-black tabular-nums tracking-hottr-display text-white">
              {m.lifetime}
            </p>
            <p className="mt-1 text-[10px] font-semibold uppercase tracking-hottr-label text-white/48">
              {m.label}
            </p>
          </li>
        ))}
      </ul>
      <p className="mt-3 text-[12px] text-white/40">
        Lifetime totals. A hard day never zeros these out.
      </p>
    </section>
  );
}
